import path from 'ramda/src/path'

export default sortFilters => path(['tab', 'fixedPayload'], sortFilters)
